// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2XBTw","Open":"SideDrawer_Open__1wUHJ","Close":"SideDrawer_Close__2vbx9","Logo":"SideDrawer_Logo__2HS4R"};